export default __webpack_public_path__ + "static/media/TopDownBottomUp_Image.0a505262.png";